import React from 'react';
import BurgerAbout from "../../images/burger-about.jpg";
import AboutImg from "../../images/about.jpg";
import Heroe1 from "../../images/heroe1.jpg";
import Heroe2 from "../../images/heroe2.jpg";
import Heroe3 from "../../images/heroe3.jpg";


const About = () => {

    return (
        <>
            <div className="card-wrapper" style={{
                backgroundImage: `url(${BurgerAbout})`,
                backgroundSize: "cover",
                backgroundPosition: "center center",
                backgroundAttachment: "fixed"
            }}>
                <h2>About our company</h2>
                <p>
                    <img src={AboutImg} alt="About" className="responsive"/>
                </p>
                <h3>A long family history...</h3>
                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ab aliquid autem beatae consequatur cupiditate
                    delectus et eveniet fuga incidunt ipsam iste magnam maiores, maxime nulla perspiciatis qui soluta ullam
                    voluptatem.</p>
                <p>Autem beatae commodi earum explicabo incidunt, reiciendis sed vel. Ad consequuntur
                    corporis cumque eligendi esse fuga, laborum modi molestias nihil, nobis non perspiciatis possimus quas quis
                    rerum, sapiente unde velit.</p>
                <p>Animi corporis distinctio expedita ipsam itaque, minus odio perferendis
                    rerum tempora. Aliquid at commodi culpa, delectus deserunt, distinctio dolore, dolores exercitationem
                    inventore iste odit perferendis perspiciatis possimus provident quaerat soluta!</p>
                <p>Amet dicta dolorem eos
                    error impedit ipsa, iusto praesentium voluptates. Et facilis iusto rem suscipit? Aliquam aut corporis,
                    delectus deleniti est excepturi natus necessitatibus neque, nobis obcaecati perspiciatis placeat
                    quisquam.</p>
                <p>Amet dicta dolorem eos
                    error impedit ipsa, iusto praesentium voluptates. Et facilis iusto rem suscipit? Aliquam aut corporis,
                    delectus deleniti est excepturi natus necessitatibus neque, nobis obcaecati perspiciatis placeat
                    quisquam.</p>
                <p>Amet dicta dolorem eos
                    error impedit ipsa, iusto praesentium voluptates. Et facilis iusto rem suscipit? Aliquam aut corporis,
                    delectus deleniti est excepturi natus necessitatibus neque, nobis obcaecati perspiciatis placeat
                    quisquam.</p>
                <p>Amet dicta dolorem eos
                    error impedit ipsa, iusto praesentium voluptates. Et facilis iusto rem suscipit? Aliquam aut corporis,
                    delectus deleniti est excepturi natus necessitatibus neque, nobis obcaecati perspiciatis placeat
                    quisquam.</p>
                <p>Amet dicta dolorem eos
                    error impedit ipsa, iusto praesentium voluptates. Et facilis iusto rem suscipit? Aliquam aut corporis,
                    delectus deleniti est excepturi natus necessitatibus neque, nobis obcaecati perspiciatis placeat
                    quisquam.</p>
            </div>


            <div className="card-wrapper" style={{
                backgroundImage: `url(${BurgerAbout})`,
                backgroundSize: "cover",
                backgroundPosition: "center center",
                backgroundAttachment: "fixed"
            }}>
                <h2>Our heroes!</h2>

                <ul className="list">
                    <li className="card-burger">
                        <img src={Heroe1} alt="Heroe 1"/>
                        <p>Brooke Johnston</p>
                        <hr className="style-hr"/>
                        <p>Chief</p>
                    </li>
                    <li className="card-burger">
                        <img src={Heroe2} alt="Heroe 2"/>
                        <p>Madeleine McKenzie</p>
                        <hr className="style-hr"/>
                        <p>Waitress</p>
                    </li>
                    <li className="card-burger">
                        <img src={Heroe3} alt="Heroe 3"/>
                        <p>Jayden Jarvis</p>
                        <hr className="style-hr"/>
                        <p>Bartender</p>
                    </li>
                </ul>
            </div>

        </>
    );
};

export default About;
